<template>
	<BarGenerator
		:options="chartOptions"
		:data="barData"
		:id="chartId"
		:dataset-id-key="datasetIdKey"
		:plugins="plugins"
		:css-classes="cssClasses"
		:styles="styles"
		:width="width"
		:height="height"
	/>
</template>

<script>
	import { Bar as BarGenerator } from "vue-chartjs";
	import {
		Chart as ChartJS,
		Title,
		Tooltip,
		Legend,
		BarElement,
		CategoryScale,
		LinearScale,
	} from "chart.js";

	ChartJS.register(
		Title,
		Tooltip,
		Legend,
		BarElement,
		CategoryScale,
		LinearScale
	);

	export default {
		name: "BarChart",
		components: { BarGenerator },
		props: {
			chartId: {
				type: String,
				default: "bar-chart",
			},
			datasetIdKey: {
				type: String,
				default: "label",
			},
			width: {
				type: Number,
				default: 400,
			},
			height: {
				type: Number,
				default: 290,
			},
			cssClasses: {
				default: "",
				type: String,
			},
			styles: {
				type: Object,
				default: () => {},
			},
			plugins: {
				type: Array,
				default: () => [],
			},
			labels: {
				type: Array,
				required: true,
			},
			data: {
				type: Array,
				required: true,
			},
			colors: {
				type: Array,
				default: () => ["#018673"], // Default color if none is provided
			},
			chartLabel: {
				default: "Branch Data",
				type: String,
			},
		},
		data() {
			return {
				barData: {
					labels: this.labels,
					datasets: [
						{
							label: this.chartLabel,
							backgroundColor: this.data.map((_, index) => {
								// Use the provided colors or fall back to the default color
								return this.colors[index % this.colors.length];
							}),
							data: this.data,
						},
					],
				},
				chartOptions: {
					responsive: true,
					maintainAspectRatio: false,
				},
			};
		},
	};
</script>
